import React, { Component } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { passwordValidator } from "../../helper/validator/changePassword.validator";
import {
  IChangePasswordProps,
  IChangePasswordState,
  IRootState,
  IChangePassword
} from "../../interfaces";
import { logger } from "../../helper/Logger";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { changePasswordRequest } from "../../action";

class ChangePassword extends Component<
  IChangePasswordProps,
  IChangePasswordState
  > {
  constructor(props: IChangePasswordProps) {
    super(props);
    this.state = {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      errors: { oldPassword: "", newPassword: "", confirmPassword: "" }
    };
  }
  componentDidUpdate = (prevProps: IChangePasswordProps) => {
    const { changePasswordReducer } = this.props;
    if (
      changePasswordReducer &&
      prevProps.changePasswordReducer &&
      changePasswordReducer.isLoading !==
      prevProps.changePasswordReducer.isLoading
    ) {
      const { isError } = changePasswordReducer;
      if (!isError) {
        this.setState({
          oldPassword: "",
          newPassword: "",
          confirmPassword: ""
        });
      }
    }
  };
  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    this.setState({
      ...this.state,
      [name]: value,
      errors: {
        ...this.state.errors,
        [name]: ""
      }
    });
  };
  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { oldPassword, newPassword, confirmPassword } = this.state;
    const data = {
      oldPassword,
      newPassword,
      confirmPassword
    };
    // To validate form fields
    const { isValid, errors } = passwordValidator(data);
    if (isValid) {
      logger("in isvalid if...........");
      const { changePassword } = this.props;
      if (changePassword) {
        logger("Api calling...........");
        await changePassword(data);
      }
    } else {
      this.setState({
        errors
      });
      return;
    }
  };
  render() {
    const { oldPassword, newPassword, confirmPassword, errors } = this.state;
    return (
      <div className="main-section">
        <div className="col-lg-12 col-md-8">
          {" "}
          <div className="profile-form">
            <Form className="row" onSubmit={this.handleSubmit}>
              <div className="col-md-12">
                <div className="d-flex align-items-center">
                  <h4 className="mb-5">
                    Change Password <span className="border-heading" />
                  </h4>
                  <button className="btn btn-submit mb-5 ml-auto" type="submit">
                    Change Password
                </button>
                </div>
              </div>

              <div className="col-lg-6 order-2 order-lg-1">
                <Form.Group className="form-password">
                  <InputGroup>
                    <input
                      type={"password"}
                      name={"oldPassword"}
                      value={oldPassword}
                      className={"form-control floating-input"}
                      placeholder=" "
                      onChange={this.handleChange}
                    />
                    <Form.Label
                      className={`floating-label ${
                        oldPassword ? "top-label" : ""
                        }`}
                    >
                      Current Password
                  </Form.Label>
                    <div className={"text-danger error-text-password"}>
                      {errors && errors.oldPassword}
                    </div>
                  </InputGroup>
                </Form.Group>

                <Form.Group className="form-password">
                  <InputGroup>
                    <input
                      type={"password"}
                      name={"newPassword"}
                      value={newPassword}
                      className={"form-control floating-input"}
                      placeholder={" "}
                      onChange={this.handleChange}
                    />
                    <Form.Label
                      className={`floating-label ${
                        newPassword ? "top-label" : ""
                        }`}
                    >
                      New Password
                  </Form.Label>
                    <div className={"text-danger error-text-password"}>
                      {errors && errors.newPassword}
                    </div>
                  </InputGroup>
                </Form.Group>

                <Form.Group className="form-password">
                  <InputGroup>
                    <input
                      type={"password"}
                      name={"confirmPassword"}
                      value={confirmPassword}
                      className={"form-control floating-input"}
                      placeholder={" "}
                      onChange={this.handleChange}
                    />
                    <Form.Label
                      className={`floating-label ${
                        confirmPassword ? "top-label" : ""
                        }`}
                    >
                      Confirm Password
                  </Form.Label>
                    <div className={"text-danger error-text-password"}>
                      {errors && errors.confirmPassword}
                    </div>
                  </InputGroup>
                </Form.Group>
              </div>

              <div className="col-lg-6 order-1 order-lg-2">
                <div className="alert-section mt-2 mb-5 mb-lg-0">
                  <p className="mb-0">
                    Passwords are a minimum of 8 characters, and must contain an
                    uppercase letter, number, and special character
                </p>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  changePasswordReducer: state.changePasswordReducer
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    changePassword: (data: IChangePassword) => {
      dispatch(changePasswordRequest(data));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
